import { useEffect, useMemo, useState } from 'react';
import { SignInMethodOption, SignInMethodType, SignInVerification } from '../../../../entities/SignInMethod';
import { useSingInMethodMutation } from '../../../../services/singnin.service';
import { dynamicCustomEventTracking } from '../../../../lib/gtm';
import { ReactComponent as WhatsAppIcon } from '../../../../images/whatsapp.svg';
import { ReactComponent as EmailIcon } from '../../../../images/email.svg';
import CodeMethodStepModel from './model';

type CodeMethodStepViewModelProps = {
  verifyData: SignInVerification;
  onMethodSelected: (method: SignInMethodOption) => void;
  onLoadingChange: (isLoading: boolean) => void;
};

export default function CodeMethodStepViewModel({
  verifyData,
  onMethodSelected,
  onLoadingChange
}: CodeMethodStepViewModelProps) {
  const model = CodeMethodStepModel;
  const [singInMethod, { data, isError, isLoading }] = useSingInMethodMutation();
  const [selectedOption, setSelectedOption] = useState<SignInMethodOption | null>(null);

  const options = useMemo(() => model.listOptions(verifyData), [verifyData]);

  useEffect(() => {
    onLoadingChange(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (data && selectedOption) {
      onMethodSelected(selectedOption);
    }
  }, [data]);

  const handleSelect = (option: SignInMethodOption) => {
    dynamicCustomEventTracking.send({ dynamicEventName: `journey_quick_access_${option.type}_ag` });
    setSelectedOption(option);
    singInMethod({ id: verifyData.oyanaid, method: option.type });
  };

  const getTypeIcon = (type: SignInMethodType) => {
    switch (type) {
      case SignInMethodType.PHONE:
        return <WhatsAppIcon />;
      case SignInMethodType.EMAIL:
        return <EmailIcon />;
      default:
        return null;
    }
  };

  return {
    options,
    isLoading,
    hasError: isError,
    errorMessage: model.ERROR_MESSAGE,
    handleSelect,
    getTypeIcon // única exceção: JSX no ViewModel para mapear enum → ícone
  };
}
